// At the top with other imports
import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom"; 
import './body.css'; // Assuming you'll create a Body.css file

import { db } from '../../Components/FirebaseComp/firebase';
import { collection, addDoc, query, where, getDocs, serverTimestamp  } from 'firebase/firestore';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { 
  MdAccessTime, MdClose, MdCheckCircle, MdLocationOn, MdPeople, 
  MdEmail, MdPhone, MdPerson, MdNotes, MdEvent, MdVolumeUp 
} from 'react-icons/md';

import emailjs from 'emailjs-com';

import { FaArrowRight } from 'react-icons/fa';


import { FaBook, FaQuoteLeft, FaRandom } from 'react-icons/fa';


const localizer = momentLocalizer(moment);



function Body() {


const img = ['ban1.jpeg', 'ban2.jpeg', 'ban3.jpeg']; 
const [currentImageIndex, setCurrentImageIndex] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % img.length
    );
  }, 10000); // Change image every 10 seconds (slower)

  return () => clearInterval(interval);
}, []);





//dhamma pada short section
// Selected verses from different chapters
  const featuredVerses = [
    {
      text: "Mind precedes all mental states. Mind is their chief; they are all mind-wrought. If with a pure mind a person speaks or acts happiness follows him like his never-departing shadow.",
      chapter: 1,
      number: 2
    },
    {
      text: "Hatred is never appeased by hatred in this world. By non-hatred alone is hatred appeased. This is a law eternal.",
      chapter: 1,
      number: 5
    },
    {
      text: "As a fish when pulled out of water and cast on land throbs and quivers, even so is this mind agitated. Hence should one abandon the realm of Mara.",
      chapter: 3,
      number: 34
    },
    {
      text: "Like a beautiful flower full of color and also fragrant, even so, fruitful are the fair words of one who practices them.",
      chapter: 4,
      number: 52
    },
    {
      text: "Better than a thousand useless words is one useful word, hearing which one attains peace.",
      chapter: 8,
      number: 100
    },
    {
      text: "To avoid all evil, to cultivate good, and to cleanse one's mind – this is the teaching of the Buddhas.",
      chapter: 14,
      number: 183
    },
    {
      text: "Health is the most precious gain and contentment the greatest wealth. A trustworthy person is the best kinsman, Nibbana the highest bliss.",
      chapter: 15,
      number: 204
    }
  ];

  const [currentVerse, setCurrentVerse] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  const getRandomVerse = () => {
    const randomIndex = Math.floor(Math.random() * featuredVerses.length);
    setCurrentVerse(randomIndex);
  };









    const [isStoryOpen, setIsStoryOpen] = useState({
      story1: false,
      story2: false,
      story3: false,
    });
    
    const toggleStory = (storyKey) => {
      setIsStoryOpen((prevState) => ({
        ...prevState,
        [storyKey]: !prevState[storyKey],
      }));
    };





const [dhammaIndex, setDhammaIndex] = useState(0);
const [dhammaExpanded, setDhammaExpanded] = useState(null);
const dhammaIntervalRef = useRef(null);

const dhammaImages = [
  { src: "/januarypoya.png", alt: "Ceremony 1" },
  { src: "/february.png", alt: "Ceremony 2" },
  { src: "/march.png", alt: "Ceremony 3" },
  { src: "/april.png", alt: "Ceremony 4" },

];

// Always show 3 images (current, next, and previous)
const dhammaVisible = [];
for (let i = -1; i <= 1; i++) {
  const index = (dhammaIndex + i + dhammaImages.length) % dhammaImages.length;
  dhammaVisible.push(dhammaImages[index]);
}

const moveNext = () => {
  setDhammaIndex((prev) => (prev + 1) % dhammaImages.length);
};

const movePrev = () => {
  setDhammaIndex((prev) => (prev - 1 + dhammaImages.length) % dhammaImages.length);
};

const handleImageClick = (image) => {
  setDhammaExpanded(image);
  clearInterval(dhammaIntervalRef.current);
};

const closeExpandedImage = () => {
  setDhammaExpanded(null);
  dhammaIntervalRef.current = setInterval(moveNext, 2000);
};

useEffect(() => {
  dhammaIntervalRef.current = setInterval(moveNext, 2000);
  return () => clearInterval(dhammaIntervalRef.current);
}, []);

const handleMouseEnter = () => clearInterval(dhammaIntervalRef.current);
const handleMouseLeave = () => {
  if (!dhammaExpanded) {
    dhammaIntervalRef.current = setInterval(moveNext, 2000);
  }
};












  






  return (
    <>
    <div className="carouselup">
      <div className="carousel-innerup">
        {img.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Slide ${index + 1}`}
            className={`carousel-itemup ${index === currentImageIndex ? 'active' : ''}`}
          />
        ))}
        

      </div>
    </div>

    {/* <div className="heading-ehipassiko">
      <h1>Ehipassiko Buddhist Center </h1>
    </div> */}
    











    <div className='middle-prent-layer'>
  <div className='middle-content-wrapper'> 

    
    <div className='middle-sacred-description'>
      <div className='middle-lotus-icon'>ධම්ම සමාධි බෞද්ධ මධ්‍යස්ථානය</div>
      {/* <h3 className='middle-dhamma-title'><i></i><br /></h3> */}
     <p className="dhamma-samadhi-para">
 <b>ශ්‍රී ධම්ම සාමධි බෞද්ධ මධ්‍යස්ථානය</b> උතුම් සම්බුද්ධ ශාසනය ආරක්ෂා කර ගනිමින් 
 ශ්‍රේෂ්ඨ බුද්ධ දර්ශනය ප්‍රචාරය කිරීමේ මහත් අරමුණින් 2008 වර්ෂයේදී ස්ථාපිත කරනු ලැබීය. 
 මෙම පුණ්‍ය භූමිය ස්ථාපිත කිරීමේ කාර්යය කරුණාපූර්ණ නායකත්වයෙන් යුතුව ගෞරවනීය හගරාපිටියේ මෛත්‍රී හිමියන් සහ ගෞරවනීය හිපන්කන්දේ සද්ධාසිරි හිමියන් විසින් ඉටු කරන ලදී. 
 එමෙන්ම ගෞරවනීය ඇඹිලිපිටියේ රාහුල හිමියන් සහ ගෞරවනීය කොරතොට ධම්ම දස්සි හිමියන්ගේ ආශීර්වාදය සහ 
 ආගමික උපදේශන මඟින් මෙම බෞද්ධ මධ්‍යස්ථානයේ ආගමික සහ පාලන කටයුතු කරනු ලබයි. 
 මෙම විහාරස්ථානය ස්ථාපිත කිරීම සඳහා අවශ්‍ය පුණ්‍ය භූමිය ව්‍යාපාරික වීරසිංහ මහතා සහ ඔහුගේ පවුලේ සාමාජිකයන් විසින් පූජා කරන ලදී.
<br /><br />
<b>ශ්‍රී ධම්ම සාමධි බෞද්ධ මධ්‍යස්ථානය</b> දේශීය වශයෙනුත්, ජාත්‍යන්තර වශයෙනුත් බුද්ධ ශාසනයේ ආරක්ෂාව හා උතුම් ධර්මය 
ප්‍රචාරය කිරීම සඳහා කැප වූ ආලෝක ස්ථම්භයක් ලෙස පවතී. වර්තමානයේ නේවාසික භික්ෂූන් වහන්සේලා දස නමකට 
අධික පිරිසක් ධර්ම අධ්‍යයනය, ධර්ම ප්‍රතිපත්තිය සහ ධර්ම දේශනා කටයුතු සඳහා නිරතව සිටින අතර, සමාජයේ ආත්මික, 
නෛතික හා සමාජීය උන්නතිය උදෙසා අගනා සේවයක් ඉටු කරමින් සිටිති. ආගමික චාරිත්‍ර, අධ්‍යාපනික වැඩසටහන්, සමාජ 
සේවා ව්‍යාපෘති සහ ජාත්‍යන්තර සම්බන්ධතා මඟින් සියලු සත්ත්වයන් අතර ප්‍රඥාව, කරුණාව සහ සාමය වර්ධනය කිරීමේ 
උතුම් මෙහෙවර මෙම මධ්‍යස්ථානය අඛණ්ඩව සිදු කරයි.
  </p>





      
    </div>

      <div className='middle-visual-container'>
      <img 
        src="/logo-dhammasamadhi.png" 
        alt="Arama Poojawa" 
        className='middle-sacred-image'
        loading='lazy'
      />
 
    </div>
    
  </div>
</div>







    <div className="body-container">





<div className="dhamma-samadhi-container">
  <h1 className="dhamma-samadhi-heading">
    වාර්ෂික පිංකම් මාලාව 2026
  </h1>

  <p className="dhamma-samadhi-para">
    අපගේ ආගමික හා සමාජීය ජීවිතයේ අතිශය වැදගත් අවස්ථාවක් වන 
    “පොහොය දිනයන්” සඳහා ඔබ සැමට ආරාධනා කරමු. 
    මෙම මාලාව තුළින් ආගමික සම්ප්‍රදායන්, ආගමික කටයුතු සහ 
    සමාජීය එකමුතුව නව පරපුරට උරුම කරවීම අපගේ අරමුණයි. 
    සියලුම දායකයන්ගේ සහභාගිත්වය හා ආශීර්වාදය සමගින් 
    මෙම පිංකම් සාර්ථක කරගැනීමට අපි බලාපොරොත්තු වෙමු.
  </p>

  <div 
    className="dhamma-carousel-container"
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
  >
    <div className="dhamma-carousel">
      {dhammaVisible.map((image, i) => (
        <div 
          key={`${image.src}-${i}`}
          className={`dhamma-item ${i === 1 ? 'dhamma-center' : ''}`}
          onClick={() => handleImageClick(image)}
        >
          <img src={image.src} alt={image.alt} />
        </div>
      ))}
    </div>
    <div className="dhamma-controls">
      <button className="dhamma-prev" onClick={movePrev}>&lt;</button>
      <button className="dhamma-next" onClick={moveNext}>&gt;</button>
    </div>
  </div>

  {dhammaExpanded && (
    <div className="dhamma-modal" onClick={closeExpandedImage}>
      <div className="dhamma-modal-content" onClick={e => e.stopPropagation()}>
        <button className="dhamma-close" onClick={closeExpandedImage}>&times;</button>
        <img 
          src={dhammaExpanded.src} 
          alt={dhammaExpanded.alt} 
          className="dhamma-expanded"
        />
        <div className="dhamma-caption">{dhammaExpanded.alt}</div>
      </div>
    </div>
  )}
</div>











     <div className="daily-time-table">
  <div className="table-header">
    <h2>
      <span className="header-icon">📅</span>
      Daily Schedule
    </h2>
    <p className="header-subtitle">Monastic Daily Routine & Spiritual Activities</p>
  </div>
  
  <div className="time-filters">
    <button className="filter-btn active">All Activities</button>

  </div>

  <div className="time-table-items">
    <div className="time-table-item morning">
      <div className="time-badge">
        <span className="time-icon"></span>
        <span className="time">05:00 AM - 06:00 AM</span>
      </div>
      <div className="activity-content">
        <span className="activity-title">Morning Meditation</span>
        <br />
        <span className="activity-description">Worship and homage to Lord Buddha and practice Meditation</span>
        <div className="activity-tags">
          <span className="tag meditation">Meditation</span>
          <span className="tag worship">Worship</span>
        </div>
      </div>
    </div>

    <div className="time-table-item morning">
      <div className="time-badge">
        <span className="time-icon"></span>
        <span className="time">06:00 AM - 08:00 AM</span>
      </div>
      <div className="activity-content">
        <span className="activity-title">Breakfast Offering</span>
          <br />
        <span className="activity-description">Breakfast Offering and spiritual services (Home visit on request)</span>
        <div className="activity-tags">
          <span className="tag offering">Offering</span>
          <span className="tag service">Home Visit</span>
        </div>
      </div>
    </div>

    <div className="time-table-item morning">
      <div className="time-badge">
        <span className="time-icon"></span>
        <span className="time">09:00 AM - 10:00 AM</span>
      </div>
      <div className="activity-content">
        <span className="activity-title">Dhamma Discussion</span>
          <br />
        <span className="activity-description">Dhamma discussion, Buddhist Counselling</span>
        <div className="activity-tags">
          <span className="tag discussion">Discussion</span>
          <span className="tag counselling">Counselling</span>
        </div>
      </div>
    </div>

    <div className="time-table-item afternoon">
      <div className="time-badge">
        <span className="time-icon"></span>
        <span className="time">10:30 AM - 12:30 PM</span>
      </div>
      <div className="activity-content">
        <span className="activity-title">Lunch Offering</span>
          <br />
        <span className="activity-description">Lunch Offering and spiritual services (Home visit on request)</span>
        <div className="activity-tags">
          <span className="tag offering">Offering</span>
          <span className="tag service">Home Visit</span>
        </div>
      </div>
    </div>

    <div className="time-table-item afternoon">
      <div className="time-badge">
        <span className="time-icon"></span>
        <span className="time">02:00 PM - 03:30 PM</span>
      </div>
      <div className="activity-content">
        <span className="activity-title">Study & Research</span>
          <br />
        <span className="activity-description">Studies and Research</span>
        <div className="activity-tags">
          <span className="tag study">Study</span>
          <span className="tag research">Research</span>
        </div>
      </div>
    </div>

    <div className="time-table-item afternoon">
      <div className="time-badge">
        <span className="time-icon"></span>
        <span className="time">04:00 PM - 06:00 PM</span>
      </div>
      <div className="activity-content">
        <span className="activity-title">Devotee Meetings</span>
          <br />
        <span className="activity-description">Meet the devotees on appointments</span>
        <div className="activity-tags">
          <span className="tag meeting">Appointments</span>
          <span className="tag consultation">Consultation</span>
        </div>
      </div>
    </div>

    <div className="time-table-item evening">
      <div className="time-badge">
        <span className="time-icon"></span>
        <span className="time">06:30 PM - 09:00 PM</span>
      </div>
      <div className="activity-content">
        <span className="activity-title">Evening Chanting</span>
          <br />
        <span className="activity-description">Worship and homage to the Lord Buddha, practice Meditation And Chanting (Home visit on request)</span>
        <div className="activity-tags">
          <span className="tag chanting">Chanting</span>
          <span className="tag meditation">Meditation</span>
          <span className="tag service">Home Visit</span>
        </div>
      </div>
    </div>
  </div>

  <div className="table-footer">

    <p className="note">* Home visits available upon request. Please schedule in advance.</p>
  </div>
</div>

    </div>




   <section className="success-stories">
  <h2 className="section-title">Inspiring Transformations at Sri Dhamma Samadhi</h2>
  <div className="stories-grid">
    
<div className="story-card">
  <div className="story-image">
    <img src="/katina.jpg" alt="Katina Pinkama" />
  </div>
  <h3>Katina Pinkama</h3>
  <p>A sacred offering ceremony rooted in gratitude and generosity.</p>
  <button className="btn-text" onClick={() => toggleStory("story1")}>
    Read Story <FaArrowRight />
  </button>
  {isStoryOpen.story1 && (
    <div className="story-detail">
      <p>
        Our annual Katina Pinkama was conducted in a serene and devotional
        atmosphere, allowing devotees to participate in the offering of robes
        and requisites to the Maha Sangha. The ceremony strengthened faith,
        unity, and the spirit of dāna within the community.
      </p>
    </div>
  )}
</div>

<div className="story-card">
  <div className="story-image">
    <img src="/mettainaction.jpg" alt="Flood Relief Support" />
  </div>
  <h3>Flood Relief Support</h3>
  <p>Extending compassion to families affected by natural disasters.</p>
  <button className="btn-text" onClick={() => toggleStory("story2")}>
    Read Story <FaArrowRight />
  </button>
  {isStoryOpen.story2 && (
    <div className="story-detail">
      <p>
        In response to recent floods, our volunteers organized the distribution
        of dry food packs and essential supplies to affected families. This
        initiative reflected the Buddhist value of compassionate action and
        timely support for those in need.
      </p>
    </div>
  )}
</div>

<div className="story-card">
  <div className="story-image">
    <img src="/dhamma-program.jpg" alt="Dhamma Program" />
  </div>
  <h3>Dhamma Program</h3>
  <p>Guiding minds through wisdom, ethics, and mindful living.</p>
  <button className="btn-text" onClick={() => toggleStory("story3")}>
    Read Story <FaArrowRight />
  </button>
  {isStoryOpen.story3 && (
    <div className="story-detail">
      <p>
        Our Dhamma programs provide an opportunity to explore the Buddha’s
        teachings through discourse, reflection, and guided practice. These
        sessions support moral development, mental clarity, and a deeper
        understanding of the path toward peace and liberation.
      </p>
    </div>
  )}
</div>

    

  </div>
</section>







   <section className="dhammapada-section">
      <div className="container">
        <div className="section-header">
          <h2>
            <FaBook /> Wisdom from the Dhammapada
          </h2>
          <p>Teachings of the Buddha for mindful living</p>
        </div>

        <div className="verse-card">
          <div className="quote-icon">
            <FaQuoteLeft />
          </div>
          
          <div className="verse-content">
            <p className="verse-text">
              "{featuredVerses[currentVerse].text}"
            </p>
            
            <div className="verse-meta">
              <span className="verse-reference">
                Dhammapada Chapter {featuredVerses[currentVerse].chapter}, Verse {featuredVerses[currentVerse].number}
              </span>
            </div>
          </div>

          <div className="verse-actions">
            <button 
              className="random-button"
              onClick={getRandomVerse}
              aria-label="Random verse"
            >
              <FaRandom /> New Verse
            </button>
            
            <button 
              className="read-more-button"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? 'Show Less' : 'Read More Verses'}
            </button>
          </div>
        </div>

        {isExpanded && (
          <div className="expanded-verses">
            <h3>Selected Teachings</h3>
            <div className="verses-grid">
              {featuredVerses.map((verse, index) => (
                <div 
                  key={index} 
                  className={`verse-item ${index === currentVerse ? 'active' : ''}`}
                  onClick={() => setCurrentVerse(index)}
                >
                  <p>"{verse.text.substring(0, 100)}..."</p>
                  <span>Chapter {verse.chapter}, Verse {verse.number}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="section-footer">
          <p>
            The Dhammapada is a collection of the Buddha's teachings in verse form. 
            It contains 423 verses divided into 26 chapters.
          </p>
          <a href="/dhammapada" className="full-link">
            Explore the Complete Dhammapada →
          </a>
        </div>
      </div>
    </section>












<div className="profile-container">
      <div className="profile-grid">
        <div className="profile-image-container">
          <img
            src="dhammasiddi himi.png" // Make sure "dharma.png" is in your public folder or accessible
            alt="Korathota Dhammasiddi"
            className="profile-image"
          />
        </div>
        <div className="profile-description">
          <h1  className="monk-heading"> පූජ්‍ය කොරතොට ධම්මසිද්ධී ස්වාමීන් වහන්සේ</h1>
       <p>පූජ්‍ය කොරතොට ධම්මසිද්ධී ස්වාමීන් වහන්සේ 1994 මාර්තු 18 වන දින උපන්හ. 2007 සැප්තැම්බර් 24 වන දින පන්නිපිටිය දෙව්රම්වෙහෙරේදී සාමණේර පැවිද්ද ලබා ගත් අතර, 2015 ජූලි 16 වන දින බලපිටිය මාදුගඟ උදකුක්ඛේපක සීමා මණ්ඩපය තුළ උපාසම්පදා මහෝත්සවය සිදුකර උතුම් උපසම්පදා භික්ෂුත්වයට පත් වූහ. එම උපාසම්පදා කර්මය සිදු කරන ලද්දේ අතිපූජ්‍ය හිපන්කන්දේ සද්ධාසිරි අනුනායක ස්වාමීන් වහන්සේ හා අතිපූජ්‍ය ඇඹිලිපිටියේ රාහුල නායක ස්වාමීන් වහන්සේගේ අනුශාසනා යටතේය.</p>

       <p>මුලික අධ්‍යාපනය කොරතොට, කඩුවෙල ශ්‍රී සෝමානන්ද රජයේ විද්‍යාලයෙන් ලැබූ අතර, මහා පිරිවෙන් අධ්‍යාපනය හිපන්කන්ද ගා/විද්‍යා සමාධි මහා පිරිවෙන, නවදගලහිදී හදාරා ඇත. 2014–2015 කාලය තුළ නුගේගොඩ සුභද්‍රාරාම විද්‍යායතන පිරිවෙනේ උසස් අධ්‍යාපනය හදාරා විශිෂ්ට ලෙස සමත්විය.</p>

       <p>අධ්‍යාපන පොදු සහතිකපත්‍ර උසස් පෙළ විභාගයෙන් සමත්ව  ජාතික ශික්ෂණ විද්‍යා ඩිප්ලෝමාව හැදෑරීම සඳහා 2018 නිට්ටඹුව සාරිපුත්ත ජාතික අධ්‍යාපන විද්‍යාපීඨයට ඇතුළත්ව වසර තුනක  පාඨමාලාව සාර්ථකව නිම කළහ. ඒහිදී ගුරු විභාගයෙන් සමස්ත ලංකාවෙන් පළමු ස්ථානය හිමිකර ගැනීමට සමත්විය.</p>

       <p>වර්තමානයේ බප/ජය පන්නිපිටිය ධර්මපාල විද්‍යාලයේ ගුරුවරයෙකු ලෙස කටයුතු කරමින් දේශයේ දරුවන්ගේ අනාගතය උදෙසා දහම් අධ්‍යාපනය ලබා දීමට කැපවී සිටිති. 2025 වසරේදී ශ්‍රී ජයවර්ධනපුර විශ්වවිද්‍යාලයෙන් මූලික උපාධිය සම්පූර්ණ කර උපාධිධාරී තත්ත්වයට පත්වීම තම අධ්‍යාපන ජීවිතයේ සුවිශේෂී කඩඉමක් විය.</p>

       <p>එමෙන්ම, විද්‍යා සමාධි ජාතික සංඝ සභාවේ විහාර සැළසුම් හා අධීක්ෂණ ලේකම් වශයෙන් කටයුතු කරමින් ශාසනික සේවාවන්හි සක්‍රීය දායකත්වයක් ලබා දෙන අතර, 2021 වසරේ සිට බෝකුන්දර ශ්‍රී ධම්ම සමාධි බෞද්ධ මධ්‍යස්ථානයේ විහාරාධිපති ස්වාමීන් වහන්සේ ලෙස පත්ව ස්වකීය නිර්මාණශීලි හැකියාවෙන් විහාරස්තානය තුළ බෞද්ධ සිතුවම් හා ප්‍රතිමා ඉදිකරමින් විහාර කර්මාන්තයේ ද යෙදෙයි . 2025 වසරේ පටන් ධම්ම සමාධි බෞද්ධ මධ්‍යස්ථානය තායිලන්තයේ  වත් පා සඒන්ධම්ම විහාරය හා අනුබද්ධ විහාරයක් ලෙස පවත්වාගනිමින් ශාන්තිධම්මරංසි (මයිත්‍රි)නාහිමිපාණන් වහන්සේ සමගින් ඒක්ව  ජාත්‍යන්තර වශයෙන් ද ලෝක ශාසනික මෙහෙවරෙහි නිරත වෙමින් බුද්ධ ශාසනය ප්‍රචාරය කිරීමේ උතුම් කාර්යය ඉටු කරනු ලබයි.</p>

        </div>
    </div>
  </div>






    </>
  );
}

export default Body;